import React from "react";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Grid } from 'semantic-ui-react'
import "./style.css";

function Footer() {
  return (
    <footer className="footer-div">
      <Col>
        <div className="copyright-info">
          <i class="copyright icon"></i>Copyright Barbara Potiriadis 2020
          <br /><i className="phone icon"></i>Phone number: 0411 796 102
            <i className="fa fa-phone-square" aria-hidden="true"></i>
          <div> <i className="marker icon"></i>Melbourne, VIC, Australia
          </div>
        </div>
      </Col>
      
        <div className="contact-panel">
          <div className="mail-div"><a href="mailto:barbarap095@gmail.com" target="_blank"><i className="mail icon"></i></a>
          </div>
          <div className="git-div"><a href="https://github.com/barbara095/" target="_blank"><i className="github icon"></i></a>
          </div>
          <div className="linked-div"><a href="https://www.linkedin.com/in/barbara-potiriadis/" target="_blank"><i className="linkedin icon"></i></a>
          </div>
        </div>
 
    </footer>
  );
}

export default Footer;
